export default __webpack_public_path__ + "83b8faf71d1ada4190ced54690a00694.png";